// extracted by mini-css-extract-plugin
export var collapsedSummary = "_oo-0";